module.exports = __webpack_public_path__ + "static/eye-closed-843b50989143119927205e132c91ce45.svg";